import {
	getCulture,
	getCurrency,
	getCurrencySymbol,
	getMarketId,
	getPageId
 } from "shared/tools/globalData";

const locale = {
	state: () => ({
		culture: getCulture(),
		currency: getCurrency(),
		currencySymbol: getCurrencySymbol(),
		marketId: getMarketId(),
		appPageId: getPageId(),
		cookieBotMarketingPermissions: false,
	}),
	getters: {
		getCulture: (state) => state.culture,
		getLanguage: (state) => {
			return /^[\w]{2}/.exec(state.culture)[0];
		},
		getCurrency: function (state) {
			return state.currency;
		},
		getCurrencySymbol: function (state) {
			return state.currencySymbol;
		},
		getMarketId: (state) => {
			return state.marketId;
		},
		getAppPageId: (state) => {
			return state.appPageId;
		},
		getCookieBotMarketingPermissions: (state) => {
			return state.cookieBotMarketingPermissions;
		},
	},
	mutations: {
		setCookieBotMarketingPermissions: (state, value) => {
			state.cookieBotMarketingPermissions = value;
		},
		setCulture: (state, value) => {
			state.culture = value;
		},
	},
	actions: {
		initCulture: ({ commit }) => {
			const culture = document.documentElement.getAttribute('data-lang') || document.documentElement.getAttribute('lang') || 'en-US';
			commit('setCulture', culture);
		},
	}
};

export default locale;
